import * as React from 'react';

import { DescriptionPage_SelfServeConfiguration_AboutModule_SubsectionName as AboutModuleSubsectionName } from '__generated__/graphql-types';

import type { ProductOverviewModuleConfig } from 'bundles/unified-description-page-common/types/moduleConfig';

type Props = {
  config?: ProductOverviewModuleConfig;
  skills?: React.ReactNode;
  description?: React.ReactNode;
  details?: React.ReactNode;
};

export const AboutSubmoduleRenderer = ({ config, skills, description, details }: Props) => {
  if (!config?.aboutModule?.subsections?.length) {
    return null;
  }

  return (
    <>
      {config?.aboutModule?.subsections?.map((subsection) => {
        switch (subsection.name) {
          case AboutModuleSubsectionName.LearningOutcomes:
            return <React.Fragment key={AboutModuleSubsectionName.LearningOutcomes}>{description}</React.Fragment>;
          case AboutModuleSubsectionName.Skills:
            return <React.Fragment key={AboutModuleSubsectionName.Skills}>{skills}</React.Fragment>;
          case AboutModuleSubsectionName.DetailsToKnow:
            return <React.Fragment key={AboutModuleSubsectionName.DetailsToKnow}>{details}</React.Fragment>;
          default:
            return null;
        }
      })}
    </>
  );
};

export default AboutSubmoduleRenderer;
